export const INIT_SITEMAP = "initSitemap";
export const FETCH_DATA_COMPLETE = "fetchDataComplete";
export const SET_MENU_STATE = "setMenuState";
export const TOGGLE_GALLERY_OVERLAY = "toggleGalleryOverlay";
export const SET_SCROLLBAR_WIDTH = "setScrollbarWidth";
